import React, { memo, useCallback } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import "./CampaignDates.scss";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { isAfter, isBefore } from "date-fns";
import { CalendarToday } from "@mui/icons-material";
import { datePickerSlotProps, datePickerStyles } from "./CampaignDatesStyles";

const CampaignDates = memo(({ startDate, endDate, setStartDate, setEndDate }) => {
  // Memoize callback functions to avoid recreation on every render
  const shouldDisableStartDate = useCallback(
    (date) => (endDate ? isAfter(date, endDate) : false),
    [endDate]
  );

  const shouldDisableEndDate = useCallback(
    (date) => (startDate ? isBefore(date, startDate) : false),
    [startDate]
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="campaign-dates">
        <div className="date-picker-with-label">
          <span className="label">Campaign Start Date</span>{" "}
          <DatePicker
            sx={datePickerStyles}
            value={startDate}
            onChange={setStartDate}
            format="yyyy-MM-dd"
            shouldDisableDate={shouldDisableStartDate}
            slotProps={datePickerSlotProps}
            slots={{
              openPickerIcon: CalendarToday
            }}
          />
        </div>
        <div className="date-picker-with-label">
          <span className="label">Campaign End Date</span>{" "}
          <DatePicker
            sx={datePickerStyles}
            value={endDate}
            onChange={setEndDate}
            format="yyyy-MM-dd"
            shouldDisableDate={shouldDisableEndDate}
            slotProps={datePickerSlotProps}
            slots={{
              openPickerIcon: CalendarToday
            }}
          />
        </div>
      </div>
    </LocalizationProvider>
  );
});

export default CampaignDates;
